import React, { useState } from 'react';
import { Select } from 'antd';
import { GalleryTags } from 'utils/data/GalleryTagsModal';
import PropTypes from 'prop-types';
import UploaderComponent from 'components/UploaderComponent/UploaderComponent';
import './UploadSection.less';

const UploadSection = (props) => {
  const [selectValue, setSelectValue] = useState([]);
  const { handleUploadImage, token } = props;
  const { Option } = Select;


  const handleOnCoverImage = (image) => {
    handleUploadImage(image.url);
  };

  /**
   * Don't needed but is required for UploaderComponent
   */
  const handleOnRemoveCoverImage = () => {};

  /**
   * Method to handler the select filter
   */
  const handlerFilterOption = (input, option) => (
    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
  );

  /**
 * HandleOnselect Image
 * @param value
 */
  const handleSelectOnchange = (value) => {
    // in future versions we'll have an array of strings, right now is for only one value
    setSelectValue([value]);
  };

  return (
    <div className="upload-section-container">
      <div className="upload-section-header">
        <Select
          showSearch
          className="upload-section-select-component"
          optionFilterProp="children"
          placeholder="Selecciona un tag (obligatorio)"
          onChange={handleSelectOnchange}
          filterOption={handlerFilterOption}
        >
          {GalleryTags.map((tag) => (
            <Option value={tag.value}>
              {tag.label}
            </Option>
          ))}
        </Select>
      </div>
      <div className="upload-section-content">
        <div className="upload-section-uploader-container">
          {selectValue.length ? (
            <UploaderComponent
              handleImage={handleOnCoverImage}
              handleOnRemove={handleOnRemoveCoverImage}
              label="Imagen de Portada"
              limit={1}
              listType="picture"
              method="post"
              tags={selectValue}
              token={token}
              type={1}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};

UploadSection.propTypes = {
  handleUploadImage: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
};

export default UploadSection;
